import React from 'react'
import styled from 'styled-typed'
import GeneralNotifications from './notification'
import { SECTION_TABS_SLOT_ID } from 'uiComponents/navigation/sectionTabsSlot'
import './pageContent.scss'

const PageContentScroll = styled.div`
    min-height: 600px;

    @media (max-width: ${(props) => props.theme.breakPoints.md}) {
        overflow: auto;
        min-height: calc(100vh - 80px - 16px);
    }
`

const PageContentSizer = styled.div`
    width: var(--page-width);
    min-width: var(--page-min-width);
    max-width: var(--page-max-width);
    margin: 0 var(--page-margin-x);
    margin-bottom: 15em;
    &.no-sidebar {
        margin: 0 auto;
    }
`

interface PageContentProps {
    children?: React.ReactNode | undefined
    className?: string
}

export function PageContent({ children, className, ...rest }: PageContentProps | React.HTMLAttributes<HTMLDivElement>) {
    return (
        <PageContentScroll className="page-content-scroll" {...rest}>
            <div id={SECTION_TABS_SLOT_ID} className="section-tabs-slot" />
            <PageContentSizer className={`PageContentSizer ${className || ''}`}>
                <GeneralNotifications />
                {children}
            </PageContentSizer>
        </PageContentScroll>
    )
}
